/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const DeviceStatus = {
    Unknown: 'Unknown',
    Online: 'Online',
    Offline: 'Offline',
    Maintenance: 'Maintenance',
    Error: 'Error'
} as const;
export type DeviceStatus = typeof DeviceStatus[keyof typeof DeviceStatus];

